
const NavUtils = {
    hasAppAccess: function (tenantRecord, app) {
        
        //sometimes tenantRecord has a subobject tenant
        if (tenantRecord.tenant) {
            tenantRecord = tenantRecord.tenant;
        }

        let appAccess = null;
        //sometimes tenantRecord has a subobject tenant
        if(tenantRecord.tenant) {
            appAccess = tenantRecord.tenant.fields.apps;
        } else {
            appAccess = tenantRecord.fields.apps;
        }

        if(appAccess) {
            const appLower = app.toLowerCase();
            const slug = appLower.startsWith('dynamic/') ? appLower.slice('dynamic/'.length) : null;
            let justApp = appAccess.filter( (thisApp) => {
                return thisApp.fields.apptype.toLowerCase() === appLower
                    || thisApp.fields.customctalink?.toLowerCase() === appLower
                    || (slug !== null && thisApp.fields.customctalink?.toLowerCase() === slug);
            });

            return justApp.length > 0;
        }

        return false;
        
    }

}

export default NavUtils;